import { Edit } from "react-admin";
import { LandingForm } from "./LandingForm";

export const LandingEdit = (props) => (
  <Edit title="Edição de Landing" {...props}>
    <LandingForm {...props} />
  </Edit>
);
